import { useState } from 'react';
import { Box } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useEntityFilters } from '../hooks/useEntityFilters';
import { useTimelineData } from '../hooks/useTimelineData';
import { TimelineBrush } from './charts/TimelineBrush';
import { NativeDashboardContent } from './NativeDashboardContent';
import { InfrastructureDashboardContent } from './InfrastructureDashboardContent';

type DashboardView = 'application' | 'infrastructure';

const useStyles = makeStyles(theme => ({
  viewToggle: {
    marginBottom: theme.spacing(1),
    '& .MuiToggleButton-root': {
      padding: '4px 16px',
      fontSize: 13,
      textTransform: 'none',
    },
  },
}));

export const ObservabilityTabContent = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const filters = useEntityFilters();
  const [view, setView] = useState<DashboardView>('application');

  const hasChaos = entity.metadata.annotations?.['chaos-mesh/enabled'] === 'true';

  // Timeline sparkline data — always 7d overview
  const { data: sparklineData, loading: sparklineLoading } = useTimelineData(filters.selectedService);

  return (
    <Box>
      {/* ── Timeline Brush ─────────────────────────────── */}
      <TimelineBrush
        sparklineData={sparklineData}
        timeRange={filters.timeRange}
        onTimeRangeChange={filters.setCustomTimeRange}
        onPresetChange={filters.setTimeRangePreset}
        presets={filters.timeRangePresets}
        activePreset={filters.activePreset}
        loading={sparklineLoading}
      />

      {/* ── Application / Infrastructure Toggle ─────────── */}
      {hasChaos && (
        <Box display="flex" justifyContent="center" mb={1}>
          <ToggleButtonGroup
            className={classes.viewToggle}
            value={view}
            exclusive
            onChange={(_, v) => v && setView(v)}
            size="small"
          >
            <ToggleButton value="application">Application</ToggleButton>
            <ToggleButton value="infrastructure">Infrastructure</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}

      {/* ── Dashboard Content ──────────────────────────── */}
      {view === 'application' || !hasChaos ? (
        <NativeDashboardContent filters={filters} />
      ) : (
        <InfrastructureDashboardContent filters={filters} />
      )}
    </Box>
  );
};
